import { getBaseApi } from "../BaseApi";

/**
 * List boutiques. Admin/supervisor/moderator can pass `sellerId` to view
 * any seller's boutiques; other roles always see their own.
 */
export function listBoutiques(opts?: { sellerId?: string }) {
  const qs = opts?.sellerId ? `?sellerId=${encodeURIComponent(opts.sellerId)}` : "";
  return getBaseApi().get(`boutiques/${qs}`);
}

export function createBoutiqueApi(input: {
  name: string;
  country?: string;
  description?: string;
}) {
  return getBaseApi().post("boutiques/", input);
}

export function updateBoutiqueApi(
  id: string,
  input: { name?: string; country?: string; description?: string }
) {
  return getBaseApi().put(`boutiques/${id}`, input);
}

export function deleteBoutiqueApi(id: string) {
  return getBaseApi().delete(`boutiques/${id}`);
}
